import styled from 'styled-components';

export const InputWrapper = styled.div`
  position: relative;
  padding: 0px !important;
  margin-bottom: 8px;

  .content-editable {
    font-family: 'Fira Sans', sans-serif;
    background: #e9ebee;
    border-radius: 5px;
    font-size: 13px;
    border: 0;
    color: #505e74;
    padding: 0.375rem 0.75rem;
    color: #505e74;
    width: 100%;
    border: none;
    height: 100px;
    overflow-y: auto;
    cursor: text;

    button {
      position: inherit;
      width: 27px;
      height: 27px;
      margin: 3px;
      font-size: 14px;
      color: transparent;
      background: transparent;
      display: inline-block;
      background-image: url(/assets/images/icons/ic_play.svg);
      background-size: 12px;
      background-repeat: no-repeat;
      background-position: 9px 7px;
      border-radius: 50%;
      box-shadow: 0px 2px 4px #00000059;
      border: none;
      padding: 0;
    }
  }
`;
